var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.vueAppClasses, attrs: { id: "app" } },
    [
      _c("router-view", {
        key: _vm.$route.fullPath,
        on: { setAppClasses: _vm.setAppClasses },
      }),
      _vm.isLogged ? _c("idle-tracking") : _vm._e(),
      _c("ApiErrorModal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }